import { useMutation, useQuery } from "@tanstack/react-query";
import {
  login,
  markAttendance,
  getUserLocation,
  getLastAttendance,
} from "../services/api";
import { AxiosResponse } from "axios";
import { saveTokenToCookies, saveAuthUser } from "../helper";
import { toast } from "react-toastify";
import { useGlobalContext, VaultUser } from "../context/globalContext";

export const useSignInUser = () => {
  const { setToken, setUser } = useGlobalContext();
  const {
    isPending,
    mutate: signInUserMutate,
    error,
    isError,
    isSuccess,
    data,
  } = useMutation({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mutationFn: (payload: any) => login(payload),
    mutationKey: ["signInUser"],
    onSuccess(data: AxiosResponse) {
      saveTokenToCookies(data?.data?.token);
      setToken(data?.data?.token);
      const user = data?.data?.data;

      const fieldsToExtract = [
        "name",
        "email",
        "department",
        "picture",
        "id",
        "firstname",
      ];

      const userDetails = fieldsToExtract.reduce((obj, field) => {
        obj[field] = user[field];
        return obj;
      }, {} as { [key: string]: string });

      const userDetailsArray = userDetails;

      saveAuthUser(userDetailsArray);
      setUser(userDetailsArray as unknown as VaultUser);
    },
    onError: (error: AxiosResponse) => {
      console.log(error);
      toast.error("Account not registered, please register through the HR.");
    },
  });
  return {
    isPending,
    signInUserMutate,
    error,
    isError,
    isSuccess,
    data,
  };
};

export const useMarkAttendance = () => {
  const {
    isPending,
    mutate: mutateMarkAttendance,
    error,
    isError,
    isSuccess,
    data,
  } = useMutation({
    mutationFn: (payload: {
      user: number;
      ip: string;
      location: string;
      checkType: string;
    }) =>
      markAttendance(
        {
          user: payload.user,
          ip: payload.ip,
          location: payload.location,
        },
        payload.checkType
      ),
    mutationKey: ["mark-attendance"],
    onSuccess(data: AxiosResponse) {
      if (!data?.data?.success) {
        toast.error(data?.data?.message);
        return;
      } else toast.success(data?.data?.message);
    },
    onError: (error: AxiosResponse) => {
      console.log(error);
      toast.error("Attendance not marked, Please check in at the Office.");
    },
  });
  return {
    isPending,
    mutateMarkAttendance,
    error,
    isError,
    isSuccess,
    data,
  };
};

export const useGetUserLocation = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["userLocation"],
    queryFn: getUserLocation,
  });

  const location = data?.data;
  return { location, isLoading, isError, error };
};

export const useGetLastAttendance = (user: number) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["lastAttendance"],
    queryFn: () => getLastAttendance(user),
  });

  const lastAttendance = data?.data?.data;
  return { lastAttendance, isLoading, isError, error };
};
